import {BrowserModule, BrowserTransferStateModule} from '@angular/platform-browser';
import {NgModule, LOCALE_ID, Type, Provider} from '@angular/core';
import {AngularFireModule} from '@angular/fire';
import {HTTP_INTERCEPTORS, HttpClientModule, HttpInterceptor} from '@angular/common/http';
import {NgxsModule} from '@ngxs/store';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ReactiveFormsModule} from '@angular/forms';
import {AngularFireAuthModule} from '@angular/fire/auth';
import {MDBBootstrapModule} from 'angular-bootstrap-md';
import {AngularFireDatabaseModule} from '@angular/fire/database';
import {registerLocaleData} from '@angular/common';
import localeEs from '@angular/common/locales/es';
import {InfiniteScrollModule} from 'ngx-infinite-scroll';
import {ServiceWorkerModule} from '@angular/service-worker';
import {states} from './data/states/index.state';
import {SizeDetectorModule} from './ui/shared/modules/size-detector/size-detector.module';
import {environment} from '../environments/environment';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {BrowserStateInterceptor} from './data/handlers/interceptors/browser-state.interceptor';
import {countryConfig} from '../country-config/country-config';
import {FooterModule} from './ui/shared/modules/footer/footer.component';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { appReducers } from './app.reducer';
import { NavbarModule } from './ui/shared/modules/navbar/navbar/navbar.component';
import { HeaderModule } from './ui/shared/modules/header/header.component';
import { JwtTokenInterceptor } from './data/handlers/interceptors/jwt-token.interceptor';
import { TalonParamsInterceptor } from './data/handlers/interceptors/talon-params.interceptor';

declare let require: any;
registerLocaleData(localeEs, 'es');

const getInterceptorObject = (interceptor: Type<HttpInterceptor>): Provider => {
  return {
    provide: HTTP_INTERCEPTORS,
    useClass: interceptor,
    multi: true,
  };
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule.withServerTransition({appId: 'ng-ftd'}),
    BrowserTransferStateModule,
    AppRoutingModule,
    ServiceWorkerModule.register('service-worker.js', {
      enabled: true,
      registrationStrategy: 'registerImmediately',
    }),
    AngularFireModule.initializeApp(countryConfig.firebaseConfig),
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    MDBBootstrapModule.forRoot(),
    SizeDetectorModule,
    NgxsModule.forRoot(states, {developmentMode: !environment.production}),
    BrowserAnimationsModule,
    InfiniteScrollModule,
    HttpClientModule,
    FooterModule,
    NavbarModule,
    HeaderModule,
    ReactiveFormsModule,
    StoreModule.forRoot( appReducers ),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    })
  ],
  providers: [
    {provide: LOCALE_ID, useValue: 'es'},
    getInterceptorObject(BrowserStateInterceptor),
    getInterceptorObject(JwtTokenInterceptor),
    getInterceptorObject(TalonParamsInterceptor),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
